import Link from 'next/link';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'next-i18next';
import { Container } from './styles';

const RequestPartnership: React.FC = () => {
  const { t } = useTranslation('common');

  return (
    <Container>
      <Link href="/br/cadastro-de-parceria">
        <div className="cadastroNav">
          <p>{t('hero-1.1.a')}</p>
          <FontAwesomeIcon icon={faArrowRight} />
        </div>
      </Link>
    </Container>
  );
};

export default RequestPartnership;
